import { BlockComponentModel } from '@/cms/types/blok-component';
import { SECTION_NAMES } from '@/integrations/trackingScripts/constants';

import { BlockHeader, BlockHeaderContent } from '@/cms/BlockHeaderContentDC';
import { BlockWrapper } from '@/cms/BlockWrapperDC';
import RichTextFieldStrapi, {
  RichTextFieldStrapiProps,
} from '@/decodo/components/atoms/RichTextField/RichTextFieldStrapi';
import { Accordion } from '@/decodo/components/molecules/accordion';

import { ProductCategoryTitlesProps } from './comparisonUtils/comparisonElements/ProductCategory';
import {
  ProductComparisonItemProps,
  ProductComparisonTable,
} from './ProductComparisonTable';

type ProductComparisonTableStrapiProps = {
  header?: BlockHeader;
  productTypeCategoryTitle?: string;
  productTypeCategoryTooltip?: RichTextFieldStrapiProps;
  keyFeaturesTitle?: string;
  keyFeaturesTooltip?: RichTextFieldStrapiProps;
  descriptionTitle?: string;
  descriptionTooltip?: RichTextFieldStrapiProps;
  productFeaturesCategoryTitles?: ProductCategoryTitlesProps[];
  firstDropdownTitle?: string;
  firstDropdownCategoryTitles?: ProductCategoryTitlesProps[];
  secondDropdownTitle?: string;
  secondDropdownCategoryTitles?: ProductCategoryTitlesProps[];
  thirdDropdownTitle?: string;
  thirdDropdownCategoryTitles?: ProductCategoryTitlesProps[];
  fourthDropdownTitle?: string;
  fourthDropdownCategoryTitles?: ProductCategoryTitlesProps[];
  scrapingDropdownTitle?: string;
  scrapingDropdownCategoryTitles?: ProductCategoryTitlesProps[];
  product_comparison_items?: {
    data: {
      attributes: ProductComparisonItemProps;
    }[];
  };
};

export function ProductComparisonTableStrapi({
  block,
  ...rest
}: BlockComponentModel<ProductComparisonTableStrapiProps>) {
  const {
    header,
    productTypeCategoryTitle,
    productTypeCategoryTooltip,
    productFeaturesCategoryTitles,
    firstDropdownTitle,
    firstDropdownCategoryTitles,
    secondDropdownTitle,
    secondDropdownCategoryTitles,
    thirdDropdownTitle,
    thirdDropdownCategoryTitles,
    fourthDropdownTitle,
    fourthDropdownCategoryTitles,
    product_comparison_items: productComparisonItems,
    keyFeaturesTitle,
    keyFeaturesTooltip,
    descriptionTitle,
    descriptionTooltip,
    scrapingDropdownTitle,
    scrapingDropdownCategoryTitles,
  } = block;

  const formattedItems: ProductComparisonItemProps[] =
    productComparisonItems?.data?.map(
      (item): ProductComparisonItemProps => item.attributes
    ) || [];

  return (
    <BlockWrapper
      {...rest}
      contentFit='mid'
      data-tracker-section={SECTION_NAMES.COMPARISON_TABLE}
    >
      <BlockHeaderContent {...header} />

      <Accordion>
        <ProductComparisonTable
          productTypeCategoryTitle={productTypeCategoryTitle}
          productTypeCategoryTooltip={
            productTypeCategoryTooltip ? (
              <div data-tracker-component='description'>
                <RichTextFieldStrapi block={productTypeCategoryTooltip} />
              </div>
            ) : null
          }
          keyFeaturesTitle={keyFeaturesTitle}
          keyFeaturesTooltip={
            keyFeaturesTooltip ? (
              <div data-tracker-component='description'>
                <RichTextFieldStrapi block={keyFeaturesTooltip} />
              </div>
            ) : null
          }
          descriptionTitle={descriptionTitle}
          descriptionTooltip={
            descriptionTooltip ? (
              <div data-tracker-component='description'>
                <RichTextFieldStrapi block={descriptionTooltip} />
              </div>
            ) : null
          }
          productFeaturesCategoryTitles={productFeaturesCategoryTitles}
          firstDropdownTitle={firstDropdownTitle}
          firstDropdownCategoryTitles={firstDropdownCategoryTitles}
          secondDropdownTitle={secondDropdownTitle}
          secondDropdownCategoryTitles={secondDropdownCategoryTitles}
          thirdDropdownTitle={thirdDropdownTitle}
          thirdDropdownCategoryTitles={thirdDropdownCategoryTitles}
          fourthDropdownTitle={fourthDropdownTitle}
          fourthDropdownCategoryTitles={fourthDropdownCategoryTitles}
          productComparisonItems={formattedItems}
          scrapingDropdownTitle={scrapingDropdownTitle}
          scrapingDropdownCategoryTitles={scrapingDropdownCategoryTitles}
        />
      </Accordion>
    </BlockWrapper>
  );
}
